import React from 'react'

import theme from './FieldList.scss'
import Table from 'common/Table';
import conf from 'configuration.json';
import {getMessage as msg} from 'MessageBundle'
import {BaseDialog} from "dialogs/BaseDialog";

export default class FieldsList extends BaseDialog {

    constructor(props) {
        super(props);

        this.state = {
            dataFields: [],
            layoutFields: [],
            initialized: true
        };

        this.dataFieldTableStructure = [
            {
                attribute: "name", label: msg("admin.fieldList.columnName"), width: '170px',
                render: (row) => {
                    return <div>${row.name}</div>;
                }
            },
            {
                attribute: "description", label: msg("admin.fieldList.columnContentDescription"),
                headStyle: theme.columnCheck, bodyStyle: theme.txtCenter,
                render: (row) => {
                    return row.description;
                }
            }
        ];

        this.layoutFieldTableStructure = [
            {
                attribute: "name", label: msg("admin.fieldList.columnName"), width: '170px',
                render: (row) => {
                    return <div>#{row.name}</div>;
                }
            },
            {
                attribute: "description", label: msg("admin.fieldList.columnDescription"),
                headStyle: theme.columnCheck, bodyStyle: theme.txtCenter,
                render: (row) => {
                    return row.description;
                }
            }
        ];
    }

    componentDidMount() {
        this.request('get', conf.rest.layoutDataFieldEndpoint).send((result) => {
            const dataFields = result.body.dataFields;
            const layoutFields = result.body.layoutFields;
            this.setState({
                dataFields: Object.keys(dataFields).map((key) => {
                    return {name: key, description: dataFields[key]};
                }),
                layoutFields: Object.keys(layoutFields).map((key) => {
                    return {name: key, description: layoutFields[key]};
                })
            });
        });
    }

    getDialog() {
        return (
            <div className={theme.fieldList}>
                <div className={theme.note}>
                    <h2>{msg("admin.fieldList.title")}</h2>
                    {msg("admin.fieldList.titleHint")}
                </div>
                <h3>{msg("admin.fieldList.dataFieldsHeader")}</h3>
                <Table fixedHeader={false} structure={this.dataFieldTableStructure} value={this.state.dataFields}/>
                <h3>{msg("admin.fieldList.layoutFieldsHeader")}</h3>
                <Table fixedHeader={false} structure={this.layoutFieldTableStructure} value={this.state.layoutFields}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Admin/FieldList/index.js